import { PDPOwnFilters, PDPOwnState } from '../own/interfaces';

export const storeName = 'pdpUser' as const;

export type PDPUserName = typeof storeName;

export const initialFilters: PDPOwnFilters = {
  reviewCycleIds: null,
};

export const pdpUserInitialState: PDPOwnState = {
  items: [],
  loading: false,
  filters: { ...initialFilters },
  init: false,
  pagination: {
    limit: 0,
    page: 1,
    total: 0,
  },
  fullData: {},
  comments: {},
};
